module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAJFBMVEUAAADWFQDWFQDWFQDWFQDWFQDWFQDWFQDWFQDWFQDWFQDWFQCSklvOAAAAC3RSTlMAuXOwbPDZwHhkX/eoODMAAAA5SURBVAjXYwAC5hAGCGDfAWUwbiLMYN4JIg0FBUW3CQoKM+yGAgYnJSW1zUpKKmA1u/Cag7AU7gwAxHcRfXfedJ4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/加号@2x.png
// module id = cgTo
// module chunks = 0